// src/socket/socket.js
import { io } from "socket.io-client";

const normalizeUrl = (value) => String(value || "").trim().replace(/\/+$/, "");

function deriveWsUrl() {
   const explicit = normalizeUrl(process.env.REACT_APP_WS_URL);
   if (explicit) return explicit;

   const apiUrlRaw = normalizeUrl(process.env.REACT_APP_API_URL);
   if (apiUrlRaw) {
      try {
         const parsed = new URL(apiUrlRaw);
         return normalizeUrl(parsed.origin);
      } catch (_) {}
   }

   if (typeof window !== "undefined" && window.location?.origin) {
      return normalizeUrl(window.location.origin);
   }

   return "https://instruireauto.site";
}

const WS_URL = deriveWsUrl();

// singleton per tab
let sharedSocket = null;
let sharedToken = null;
let refCount = 0;

function normToken(token) {
   const t = String(token || "").trim();
   return t || null;
}

export function acquireSocket(token) {
   const t = normToken(token);
   if (!t) return null;

   // reuse același socket dacă token-ul e identic
   if (sharedSocket && sharedToken === t) {
      refCount += 1;
      return sharedSocket;
   }

   // token diferit => închide vechiul
   if (sharedSocket) {
      try {
         sharedSocket.disconnect();
      } catch (_) {}
      sharedSocket = null;
      sharedToken = null;
      refCount = 0;
   }

   sharedToken = t;

   sharedSocket = io(WS_URL, {
      transports: ["websocket"],
      // tokenul doar în pachetul de conectare: în adresă (query) ajungea în logurile nginx.
      // Serverul citește `auth.token` din 2026-10-16 (ws-jwt.guard) — pe PROD frontendul acesta merge doar după el.
      auth: { token: t },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      forceNew: false,
      multiplex: true,
   });

   refCount = 1;
   return sharedSocket;
}

export function releaseSocket(socket) {
   if (!sharedSocket || socket !== sharedSocket) return;

   refCount = Math.max(0, refCount - 1);

   if (refCount === 0) {
      try {
         sharedSocket.disconnect();
      } catch (_) {}
      sharedSocket = null;
      sharedToken = null;
   }
}
